export default {
  getEditProfile: (state) => {
    return state.setProfileState;
  },
};
